import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { BesichtigungsStatiServiceModule } from '..';
import { BesichtigungsStatiSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    BesichtigungsStatiServiceModule
  ],
  declarations: [BesichtigungsStatiSorterComponent],
  exports: [BesichtigungsStatiSorterComponent],

})
export class BesichtigungsStatiSorterComponentModule { }
